/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Ignore_NoteInputs */

const vi_reconcile_ignore_note = /** @type {(inputs: Reconcile_Ignore_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do (không phải tiền đơn hàng)`)
};

/**

* @param {Reconcile_Ignore_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_ignore_note = /** @type {((inputs?: Reconcile_Ignore_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Ignore_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_ignore_note(inputs)
});